import { BaseContainerModel } from '../base-container.model';

import {
  bl_pgw_contract_hdr_RowClass,
  bl_pgw_contract_hdr_RowInterface,
  bl_pgw_contract_event_RowInterface
} from '../../dbschema';

export class PGWContractContainerModel extends BaseContainerModel {
  bl_pgw_contract_hdr: bl_pgw_contract_hdr_RowInterface = new bl_pgw_contract_hdr_RowClass();
  bl_pgw_contract_events: bl_pgw_contract_event_RowInterface[] = [];
}
